import { useMatch } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { Cart } from '../../Cart';
import CLOSE from '../../../assets/imgs/icon/close.svg';
import { Divider } from '../../../components/Divider';
import { ButtonLink } from '../../../GlobalComponents/ButtonLink';
import { Flex } from '../../../GlobalComponents/Flex';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { Modal as ModalComponent } from '../../../GlobalComponents/Modal';
import { isCartModalOpenState } from '../../../Header/atoms';
import { currentTransactionState } from '../../atoms';
// import { Header, Items, Totals } from '..';
import { Header } from '../Header';
import { Items } from '../Items';
import { Totals } from '../Totals';
import { useAppSelector } from '../../../reduxstore/hooks';
import { RootStates } from '../../../reduxstore';
import { on_checkout_products } from '../../../utils/gtag';

export const Modal: React.FC = () => {
	const match = useMatch('/product/edit/:id');
	const [isOpen, setIsOpen] = useRecoilState(isCartModalOpenState);
	const isAuthenticated = useAppSelector(
		state => state.authReducer.accessToken
	);
	const { items, subTotal, taxAmount, total } = useRecoilValue(
		currentTransactionState
	);

	const unavailableProductIds = useAppSelector(
		(state: RootStates) => state.uiReducer.unavailableProductIds
	);

	const unavailableItem = items.filter(item =>
		unavailableProductIds.includes(Number(item.id))
	);

	// TODO - Needs to Updated the UI
	if (unavailableItem.length) {
		// console.log('unavailableItem', unavailableItem);
		alert('Some of the item is not available to place the order.');
	}

	const onCheckOut = () => {
		const indexed: { [key: string]: string } = {};
		items.forEach(item => {
			indexed[item.product.name] = item.product.name;
		});
		const productNames = Object.keys(indexed).join(', ');
		on_checkout_products({
			checkout_products_name: productNames,
			user_type: isAuthenticated ? 'logged_in' : 'guest'
		});
		setIsOpen(false);
	};

	return (
		<ModalComponent
			isOpen={isOpen}
			toggleHandler={() => setIsOpen(isOpen => !isOpen)}
		>
			{items.length === 0 ? (
				'Your cart is empty.'
			) : (
				<Cart>
					<Flex
						$flexDirection="row"
						$width="100%"
						$alignItems="center"
						$justifyContent="space-between"
					>
						<Title>Current Order</Title>
						<IconButton
							url={CLOSE}
							alt="X"
							onClick={() => setIsOpen(isOpen => !isOpen)}
						/>
					</Flex>
					<Divider />
					<Header />
					<Divider />
					<Items
						items={items}
						checkIsItemEditable={id =>
							!match || match.params.id !== id
						}
						divider={<Divider my={2} borderColor="light" />}
					/>
					<Divider />
					<Totals
						subTotal={subTotal}
						total={total}
						taxAmount={taxAmount}
					/>
					<Divider />
					<Flex $justifyContent="flex-end">
						<ButtonLink to="/checkout" onClick={onCheckOut}>
							Checkout
						</ButtonLink>
					</Flex>
				</Cart>
			)}
		</ModalComponent>
	);
};

export const Title = styled.h1`
	font-size: 32px;
	line-height: 100%;
	color: #f47920;
	width: 100%;
	max-width: 570px;
	font-weight: 700;

	@media (max-width: 600px) {
		font-size: 28px;
	}
`;
